/**
 * /*
 *   支持直接替换整个快捷面板，
 *   支持默认中过滤自己想要的
 *   事件转发，
 *
 * @format
 */


import { isFunction } from 'lodash'
import { createDiffernetShortcutsOnDateType } from '../utils'

import ShortcutsCom from './shortcuts'
import ShortcutMonth from './shortcut-month'
import '../style/shortcuts.scss'

/*
  用户使用：如果是数组对象的时候直接替换，如果是函数 则把所有默认的给它，让它自己去过滤。

*/

export default {
  name: 'KyeShortcutsWrap',
  functional: true,
  render(h, context) {
    const {
      shortcuts = [],
      handleShortcutClick,
      handleShortcutMonthClick,
      type = 'date',
      currentView,
      showMonthSelect = false,
      changeShortcutMonth,
      disabledMonth
    } = context.props
    const defaultShortcuts = [...createDiffernetShortcutsOnDateType(type)]
    let data = (Array.isArray(shortcuts) && shortcuts.length) || isFunction(shortcuts) ? shortcuts : defaultShortcuts
    if (isFunction(data)) {
      data = data(defaultShortcuts)
    }
    if (!data) {
      return null
    }
    const shortcutsAttrs = {
      props: {
        shortcuts: data,
        handleShortcutClick,
      },
    }
    const shortcutsMonthAttrs = {
      props: {
        changeShortcutMonth,
        handleShortcutMonthClick,
        disabledMonth
      }
    }
    return (
      <div
        class={['kye-shortcuts', currentView]}
        ref="scrollbar"
      >
        { showMonthSelect ? <ShortcutMonth {...shortcutsMonthAttrs}></ShortcutMonth> : <ShortcutsCom {...shortcutsAttrs}></ShortcutsCom> }
      </div>
    )
  },
}



// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker2/src/basic/shortcuts-wrap.js